import { Component, inject, OnInit } from '@angular/core';
import { JoinApplyRequest, JoinApplyService } from '@app/services/join-apply/join-apply.service';
import { provideCommonAngularModules } from '@app/share/provideAngularModules';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-join-apply-modal',
  standalone: true,
  templateUrl: './joinApplyModal.component.html',
  styleUrl: './joinApplyModal.component.less',
  imports: [TranslatePipe, NzButtonModule, ...provideCommonAngularModules()],
})
export class JoinApplyModalComponent implements OnInit {
  joinApplyService = inject(JoinApplyService);
  private translateService = inject(TranslateService);
  private nzMessageService = inject(NzMessageService);

  ngOnInit(): void {}

  getJoinApplyMessage(item: JoinApplyRequest): string {
    return this.translateService.instant('JoinApplyMessage', {
      applicant: item.applicantFullName,
      user: item.userName,
    });
  }

  onApprove(item: JoinApplyRequest): void {
    if (item.processing) {
      return;
    }
    this.joinApplyService.setJoinApplyRequestProcessing(item.request_id, item.applicantId, true);
    this.joinApplyService.approveJoinApply(item).subscribe({
      next: () => {
        this.joinApplyService.resolveJoinApplyByRequestId(item.request_id);
        this.nzMessageService.success(this.translateService.instant('JoinApplyApproved'));
      },
      error: (error) => {
        this.joinApplyService.setJoinApplyRequestProcessing(item.request_id, item.applicantId, false);
        this.nzMessageService.error(error?.error?.msg || this.translateService.instant('JoinApplyApproveFailed'));
      },
    });
  }

  onReject(item: JoinApplyRequest): void {
    if (item.processing) {
      return;
    }
    this.joinApplyService.setJoinApplyRequestProcessing(item.request_id, item.applicantId, true);
    this.joinApplyService.rejectJoinApply(item).subscribe({
      next: () => {
        this.joinApplyService.resolveJoinApplyByRequestId(item.request_id);
        this.nzMessageService.success(this.translateService.instant('JoinApplyRejected'));
      },
      error: (error) => {
        this.joinApplyService.setJoinApplyRequestProcessing(item.request_id, item.applicantId, false);
        this.nzMessageService.error(error?.error?.msg || this.translateService.instant('JoinApplyRejectFailed'));
      },
    });
  }
}
